/**
 * 对话里照片的进度按哪一档说（ASSET-UI-009 三态：冲洗中／没冲洗出来／还没确认；CONTRACT-SYNC-I108）。
 * I108 起问照片那一条（PhotoAsk.status）多了 checking：I 10-09 定先和 processing 落在同一档「冲洗中」——
 * 对话里那张 01 插图、「随信的照片还在冲洗」，TA 的手机首屏预览「照片还在冲洗」；照样不给任何重试、重画。
 * 来信上的 photo_status 契约里没有 checking，前端此刻也还没读 PhotoAsk.status（接线归 PHONE-CHAT-01）：
 * 先把这一档对好，后端在哪儿给了 checking 都不会落空成什么都不显示。其余状态原样。
 */
import type { PhotoAskStatus, PhotoStatus } from "@/shared/contracts";

export function photoStage(status: PhotoStatus | PhotoAskStatus | null | undefined): PhotoStatus | null | undefined {
  return status === "checking" ? "processing" : status;
}
